module.exports = __webpack_public_path__ + "static/media/Trash.e10725a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Trash.svg
// module id = 1125
// module chunks = 0